import $ from './jquery-shim.js';

export default class Form {
  constructor() {
    this.dataset();
  }

  /**
   * 問い合わせフォームのセレクトオプションを設定する
   */
  dataset() {
    $('.js-option-set').click(function () {
      var select = $(this).data('select');
      $('input[value="' + select + '"]').prop('checked', true);
    });
  }
}
